import { type NotificationType } from '@/redux/slices/notificationSlice'
import type { EntrySmsTaskFailActivity } from '@/typings/domain'
import ItemWrapper from './ItemWrapper'

export default function EntrySmsTaskFail({ notification }: { notification: NotificationType }) {
  const activity = notification.activity as EntrySmsTaskFailActivity
  const formInfo = activity.formInfo

  if (!formInfo) return null

  return <ItemWrapper notification={notification}>《{formInfo.formName}》短信发送失败</ItemWrapper>
}
